import { AxiosError } from 'axios'
import RPCError from '../error'
const isDevelopment = import.meta.env.VITE_APP_IS_DEVELOPMENT === 'true'

export const logError = (error: unknown) => {
  if (!isDevelopment) return
  if (error instanceof AxiosError) {
    console.error(
      `HTTP Error (Status: ${error.status}, StatusText: ${error.message}, ResponseBody:`,
      error.response?.data,
    )
  } else if (error instanceof RPCError) {
    console.error(`RPC Error (Code: ${error.code}): ${error.message}`)
  } else {
    console.error('Unexpected error:', error)
  }
}

export default logError
